/* eslint-disable no-restricted-imports */
import React, { Suspense } from 'react';
import type {
  GroupedVirtuosoHandle,
  GroupedVirtuosoProps,
  ListRange,
  VirtuosoHandle,
  VirtuosoProps,
} from 'react-virtuoso';

import { Stack } from '@lyearn/ui';
import Loader from '@/components/Loader';

const LazyGroupedVirtuoso = React.lazy(() => {
  return import(/* webpackChunkName: "react-virtuoso" */ 'react-virtuoso').then((exports) => {
    return { default: exports.GroupedVirtuoso };
  });
});

const VirtualizedGroupedList = React.forwardRef(
  (
    props: GroupedVirtuosoProps<any, any> & { loader?: React.ReactNode },
    ref: React.Ref<GroupedVirtuosoHandle>,
  ) => {
    const { loader, ...rest } = props;
    return (
      <Suspense
        fallback={
          loader ? (
            loader
          ) : (
            <Stack
              alignItems="center"
              className="min-h-[200px] w-full flex-1"
              justifyContent="center">
              <Loader />
            </Stack>
          )
        }>
        <LazyGroupedVirtuoso ref={ref} {...rest} />
      </Suspense>
    );
  },
);

export type { GroupedVirtuosoHandle, ListRange, VirtuosoHandle, VirtuosoProps };

export default VirtualizedGroupedList;
